import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { getRecentMilestones } from '../../utils/activityHelpers';
import { WorldZone } from '../shared/WorldZone';
import { Card } from '../ui/Card';
import { itemVariants } from '../shared/animations';
interface MilestonesSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function MilestonesSection({
  state,
  selectedGroup
}: MilestonesSectionProps) {
  const milestones = getRecentMilestones(state, selectedGroup);
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'level_up':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'subject_complete':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'streak':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'first_practice':
        return 'bg-green-100 text-green-700 border-green-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  };
  return <WorldZone icon={Trophy} title="Mijn Mijlpalen" accentColor="bg-amber-100 text-amber-600" data-id="element-1670">
      {milestones.length === 0 ? <Card className="p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 rounded-[2rem]" data-id="element-1671">
          <p className="text-slate-500 font-medium" data-id="element-1672">
            Ga oefenen om je eerste mijlpaal te verdienen! 🎯
          </p>
        </Card> : <div className="flex overflow-x-auto pb-4 -mb-4 md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 snap-x" data-id="element-1673">
          {milestones.map((milestone, i) => <motion.div key={`${milestone.type}-${milestone.timestamp}-${i}`} variants={itemVariants} className="min-w-[240px] snap-start" data-id="element-1674">
              <Card className={`p-4 flex items-center gap-4 border-2 rounded-[1.5rem] ${getTypeColor(milestone.type)} bg-opacity-50`} data-id="element-1675">
                <div className="text-3xl bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-1676">
                  {milestone.emoji}
                </div>
                <div className="flex-1" data-id="element-1677">
                  <p className="font-bold text-sm leading-tight" data-id="element-1678">
                    {milestone.label}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </WorldZone>;
}